<template>
    <div class="roles">
        <Roles/>
    </div>
</template>

<script>
import Roles from '@/components/Roles.vue'
export default {
    name: 'roles',
    components: {
        Roles
    }
}
</script>